/**
 * @generated SignedSource<<e6aafa2f1b08b2c9e08adb051048892e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageFooter_siteFooter$data = {
  readonly footer: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
  }>;
  readonly " $fragmentType": "PageFooter_siteFooter";
};
export type PageFooter_siteFooter$key = {
  readonly " $data"?: PageFooter_siteFooter$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageFooter_siteFooter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageFooter_siteFooter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "footer",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SimpleLink_simpleLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SiteInfo",
  "abstractKey": null
};

(node as any).hash = "23ec71121b9b37d312248f527495623a";

export default node;
